import { defineNuxtPlugin } from '#app'
import WebPageTypeView from '~/components/bubbles/view/WebPageTypeView.vue'
import BookTypeView from '~/components/bubbles/view/BookTypeView.vue'
import YouTubeTypeView from '~/components/bubbles/view/YouTubeTypeView.vue'
import TwitterTypeView from '~/components/bubbles/view/TwitterTypeView.vue'
import InstagramTypeView from '~/components/bubbles/view/InstagramTypeView.vue'
import MovieTypeView from '~/components/bubbles/view/MovieTypeView.vue'
import StandardView from '~/components/bubbles/view/StandardView.vue'
import TextTypeView from '~/components/bubbles/view/TextTypeView.vue'
import ImageTypeView from '~/components/bubbles/view/ImageTypeView.vue'

import DefaultDetailedView from '~/components/bubbles/detailed/DefaultDetailedView.vue'
import WebPageDetailedView from '~/components/bubbles/detailed/WebPageDetailedView.vue'
import YouTubeDetailedView from '~/components/bubbles/detailed/YouTubeDetailedView.vue'
import InstagramDetailedView from '~/components/bubbles/detailed/InstagramDetailedView.vue'
import TwitterDetailedView from '~/components/bubbles/detailed/TwitterDetailedView.vue'
import BookDetailedView from '~/components/bubbles/detailed/BookDetailedView.vue'
import RestaurantDetailedView from '~/components/bubbles/detailed/RestaurantDetailedView.vue'
import CoffeeDetailedView from '~/components/bubbles/detailed/CoffeeDetailedView.vue'
import HotelDetailedView from '~/components/bubbles/detailed/HotelDetailedView.vue'
import BarDetailedView from '~/components/bubbles/detailed/BarDetailedView.vue'
import PlaceDetailedView from '~/components/bubbles/detailed/PlaceDetailedView.vue'
import MovieDetailedView from '~/components/bubbles/detailed/MovieDetailedView.vue'
import DoesNotExist from '~/components/bubbles/detailed/DoesNotExist.vue'
import TextDetailedView from '~/components/bubbles/detailed/TextDetailedView.vue'
import ImageDetailedView from '~/components/bubbles/detailed/ImageDetailedView.vue'
import AppLink from '@/components/ui/link/AppLink.vue'

export default defineNuxtPlugin((nuxtApp) => {
  // Register page views
  nuxtApp.vueApp.component('WebPageTypeView', WebPageTypeView)
  nuxtApp.vueApp.component('StandardView', StandardView)
  nuxtApp.vueApp.component('BookTypeView', BookTypeView)
  nuxtApp.vueApp.component('YouTubeTypeView', YouTubeTypeView)
  nuxtApp.vueApp.component('TwitterTypeView', TwitterTypeView)
  nuxtApp.vueApp.component('InstagramTypeView', InstagramTypeView)
  nuxtApp.vueApp.component('MovieTypeView', MovieTypeView)
  nuxtApp.vueApp.component('TextTypeView', TextTypeView)
  nuxtApp.vueApp.component('ImageTypeView', ImageTypeView)

  // Register bubble views
  nuxtApp.vueApp.component('DoesNotExist', DoesNotExist)
  nuxtApp.vueApp.component('DefaultDetailedView', DefaultDetailedView)
  nuxtApp.vueApp.component('WebPageDetailedView', WebPageDetailedView)
  nuxtApp.vueApp.component('YouTubeDetailedView', YouTubeDetailedView)
  nuxtApp.vueApp.component('InstagramDetailedView', InstagramDetailedView)
  nuxtApp.vueApp.component('TwitterDetailedView', TwitterDetailedView)
  nuxtApp.vueApp.component('BookDetailedView', BookDetailedView)
  nuxtApp.vueApp.component('RestaurantDetailedView', RestaurantDetailedView)
  nuxtApp.vueApp.component('BarDetailedView', BarDetailedView)
  nuxtApp.vueApp.component('PlaceDetailedView', PlaceDetailedView)
  nuxtApp.vueApp.component('MovieDetailedView', MovieDetailedView)
  nuxtApp.vueApp.component('TextDetailedView', TextDetailedView)
  nuxtApp.vueApp.component('CoffeeDetailedView', CoffeeDetailedView)
  nuxtApp.vueApp.component('HotelDetailedView', HotelDetailedView)
  nuxtApp.vueApp.component('ImageDetailedView', ImageDetailedView)

  // Register AppLink component globally
  nuxtApp.vueApp.component('AppLink', AppLink)
})
